<template>
    <section
        id="features"
        class="grey lighten-3"
      >
        <div class="py-12"></div>

        <v-container class="text-center">
          <h2 class="display-2 font-weight-bold mb-3">{{$t("technologies")}}</h2>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-responsive
            class="mx-auto title font-weight-light mb-8"
            max-width="720"
          >
            {{$t("textTechnologies")}}
          </v-responsive>
          <v-row>
            <v-col cols="12" sm="8" offset-sm="2" xs="8" offset-md="2" md="8" offset-lg="2" lg="8" offset-xl="2" xl="8">
              <v-row
                align="center"
                justify="center"
                class="grey lighten-3"
              >
                <v-col cols="3" sm="3" xs="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-img src="../../assets/img/tools/angular.png" v-on="on"></v-img>
                    </template>
                    <span>Angular</span>
                  </v-tooltip>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="3" sm="3" xs="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-img src="../../assets/img/tools/react.png" v-on="on"></v-img>
                    </template>
                    <span>React</span>
                  </v-tooltip>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="3" sm="3" xs="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-img src="../../assets/img/tools/vue.png" v-on="on"></v-img>
                    </template>
                    <span>Vue</span>
                  </v-tooltip>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="3" sm="3" xs="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-img src="../../assets/img/tools/svelte.png" v-on="on"></v-img>
                    </template>
                    <span>Svelte</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="8" offset-sm="2" offset-md="2" md="8" offset-lg="2" lg="8" offset-xl="2" xl="8">
              <v-row
                align="center"
                justify="center"
                class="grey lighten-3"
              >
                <v-col cols="3" sm="3" xs="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-img src="../../assets/img/tools/git.png" v-on="on"></v-img>
                    </template>
                    <span>Git</span>
                  </v-tooltip>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="3" sm="3" xs="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-img src="../../assets/img/tools/graphql.png" v-on="on"></v-img>
                    </template>
                    <span>GraphQL</span>
                  </v-tooltip>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="3" sm="3" xs="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-img src="../../assets/img/tools/mariadb.png" v-on="on"></v-img>
                    </template>
                    <span>MariaDB</span>
                  </v-tooltip>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="3" sm="3" xs="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-img src="../../assets/img/tools/mongodb.png" v-on="on"></v-img>
                    </template>
                    <span>MongoDB</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="8" offset-sm="2" offset-md="2" md="8" offset-lg="2" lg="8" offset-xl="2" xl="8">
              <v-row
                align="center"
                justify="center"
                class="grey lighten-3"
              >
                <v-col cols="3" sm="3" xs="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-img src="../../assets/img/tools/nodejs.png" v-on="on"></v-img>
                    </template>
                    <span>Nodejs</span>
                  </v-tooltip>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="3" sm="3" xs="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-img src="../../assets/img/tools/php.png" v-on="on"></v-img>
                    </template>
                    <span>Php</span>
                  </v-tooltip>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="3" sm="3" xs="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-img src="../../assets/img/tools/python.png" v-on="on"></v-img>
                    </template>
                    <span>Python</span>
                  </v-tooltip>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="3" sm="3" xs="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-img src="../../assets/img/tools/postgresql.png" v-on="on"></v-img>
                    </template>
                    <span>Postgresql</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="8" offset-sm="2" offset-md="2" md="8" offset-lg="2" lg="8" offset-xl="2" xl="8">
              <v-row
                align="center"
                justify="center"
                class="grey lighten-3"
              >
              <v-col cols="3" sm="3" xs="6">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-img src="../../assets/img/tools/wordpress.png" v-on="on"></v-img>
                  </template>
                  <span>Wordpress</span>
                </v-tooltip>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="3" sm="3" xs="6">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-img src="../../assets/img/tools/laravel.png" v-on="on"></v-img>
                  </template>
                  <span>Laravel</span>
                </v-tooltip>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="3" sm="3" xs="6">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-img src="../../assets/img/tools/django.png" v-on="on"></v-img>
                  </template>
                  <span>Django</span>
                </v-tooltip>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="3" sm="3" xs="6">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-img src="../../assets/img/tools/cplus.png" v-on="on"></v-img>
                  </template>
                  <span>C++</span>
                </v-tooltip>
              </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
    </section>    
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>

</style>